import { render, staticRenderFns } from "./MedicalCompanionPage.vue?vue&type=template&id=2c6bb563&"
import script from "./MedicalCompanionPage.vue?vue&type=script&lang=js&"
export * from "./MedicalCompanionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports